<template>
  <div class="evaluate-stars-base" v-if="commentCount > 0">
    <span class="stars">
      <span
        v-for="n of 5"
        :class="`star${getStarClass(n)}`"
        :key="n"></span>
    </span>
    <span class="average" v-if="showAvarage">{{ point.toFixed(fixedNum) }}</span>
    <span class="comment-count" v-if="showCount">({{ commentCount }}件)</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'EvaluateStars',

  props: {
    fixedNum: {
      type: Number,
      default() {
        return 1
      }
    },
    showAvarage: {
      type: Boolean,
      default() {
        return false
      }
    },
    showCount: {
      type: Boolean,
      default() {
        return true
      }
    },
    stars: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    itemData() {
      if(this.stars == null) {
        return
      }
      return this.stars
    },
    point() {
      let pt = 0
      if(this.itemData != null) {
        pt = parseFloat(this.itemData.evaluation)
      }
      return pt > 0 ? pt / 3 * 5 : 0 // ポイントを3 -> 5 ベースに変換
    },
    commentCount() {
      let cnt = 0
      if( this.itemData != null && this.itemData.comments_count != null ) {
        cnt = this.itemData.comments_count
      }
      return cnt
    }
  },
  methods: {
    getStarClass(idx) {
      const val = this.point - (idx - 1)
      return val >= 1 ? ' full' : (val >= 0.5 ? ' half' : '')
    }
  }
}
</script>

<style scoped lang="scss">
.evaluate-stars-base {
  font-size: 11px;
  .star {
    display: inline-block;
    width: 1em;
    height: 1em;
    background: url('/static/img/top/star_gray.svg') no-repeat center center;
    background-size: cover;
    margin-right: 3px;

    &.full {
      background: url('/static/img/top/star_yellow.svg') no-repeat center center;
      background-size: cover;
    }

    &.half {
      background: url('/static/img/top/star_half.svg') no-repeat center center;
      background-size: cover;
    }
  }
  .comment-count {
    color: #676767;
    vertical-align: 0.2em;
    font-size: 10px;
    display: inline-block;
    transform: translate(-6px, 1px) scale(0.8);
    @media screen and (min-width: 768px) {
      font-size: 12px;
    }

  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/EvaluateStars.vue